import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const INLINE_LINE_HEIGHT = "12px";

export const StyledLink = styled.a`
    text-decoration: none;
    color: ${colorsPalettes.blue[300]};
    display: block;
`;

export const StyledAgentCaption = styled.div<{ isInline: boolean }>`
    user-select: none;

    ${({ isInline }) => {
        if (isInline) {
            return css`
                line-height: ${INLINE_LINE_HEIGHT};

                ${SWReactIcons} {
                    display: inline-block;
                    margin-left: 4px;
                    vertical-align: text-bottom;
                }
            `;
        }

        return css`
            display: flex;
            align-items: center;
            gap: 4px;
            margin: 0 0 22px;
        `;
    }};
`;
